import { Menu, MenuItem, Theme, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuItemRoot: {
      minHeight: "auto",
    },
  })
);

interface MultiQueryLabelMenuProps<T extends string> {
  queryLabels: T[];
  selectedLabel: T;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onSelect: (label: T) => void;
}

const MultiQueryLabelMenu = <T extends string>({
  queryLabels,
  anchorEl,
  onClose,
  onSelect,
  selectedLabel,
}: MultiQueryLabelMenuProps<T>) => {
  const classes = useStyles();

  let menuContent: React.ReactNode = queryLabels.map(queryLabel => (
    <MenuItem
      key={queryLabel}
      onClick={() => {
        onSelect(queryLabel);
        onClose();
      }}
      classes={{ root: classes.menuItemRoot }}
      dense
      selected={queryLabel === selectedLabel}
    >
      <Typography variant="subtitle1">{queryLabel}</Typography>
    </MenuItem>
  ));
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      {menuContent}
    </Menu>
  );
};

export default MultiQueryLabelMenu;
